<template>
    <div class="d-flex flex-column overflow-hidden">
        <b-form
            v-on:submit.prevent="$_onSubmit"
            class="d-flex flex-column overflow-hidden"
        >
            <div class="scrollable mb-3">
                <b-container>
                    <category
                        :categories="categories"
                        :inputFields="inputFields"
                        id="kvk"
                        @onInput="$_validateInput($event)"
                        :invalidFieldValueErrorMessage="
                            invalidFieldValueErrorMessage
                        "
                    />
                </b-container>
            </div>
            <div v-if="invalidForm" class="errormsg px-4 mb-2">
                {{ invalidFormErrorMessage }}
            </div>
            <b-container>
                <b-row>
                    <b-col class="text-right pb-4">
                        <b-button variant="primary" type="submit">
                            <span>
                                {{ $t('searchButtonText') }}
                            </span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>

<script>
    import Category from './ApiCategory.vue';
    import { FIELD_TYPE } from '../../../constants';

    export default {
        components: { category: Category },
        data() {
            return {
                categories: [
                    {
                        label: this.$t('kvk.searchCat1'),
                        category: 1,
                        expanded: true
                    },
                    {
                        label: this.$t('kvk.searchCat2'),
                        category: 2,
                        expanded: false
                    },
                    {
                        label: this.$t('kvk.searchCat3'),
                        category: 3,
                        expanded: false
                    }
                ],
                invalidFieldValueErrorMessage: '',
                invalidForm: false,
                invalidFormErrorMessage: '',
                inputFields: [
                    {
                        label: this.$t('kvk.kvkNumber'),
                        key: 'kvkNummer',
                        value: '',
                        category: 1,
                        maxlength: 8,
                        pattern: '[0-9]{8}',
                        title: '8 cijfers'
                    },
                    {
                        label: this.$t('kvk.rsinNumber'),
                        key: 'rsin',
                        value: '',
                        category: 1,
                        maxlength: 9,
                        pattern: '[0-9]{9}',
                        title: '9 cijfers'
                    },
                    {
                        label: this.$t('kvk.branchNumber'),
                        key: 'vestigingsnummer',
                        value: '',
                        category: 1,
                        maxlength: 12,
                        pattern: '[0-9]{12}',
                        title: '12 cijfers'
                    },
                    {
                        label: this.$t('kvk.tradeName'),
                        key: 'handelsnaam',
                        value: '',
                        category: 1,
                        maxlength: 100,
                        minlength: 3
                    },
                    {
                        label: this.$t('kvk.straatnaam'),
                        key: 'straatnaam',
                        value: '',
                        category: 2,
                        maxlength: 100,
                        minlength: 3
                    },
                    {
                        label: this.$t('kvk.postcode'),
                        key: 'postcode',
                        value: '',
                        category: 2,
                        maxlength: 6,
                        pattern: '[1-9][0-9]{3}(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}',
                        title: 'formaat: 1234ab of 1234AB'
                    },
                    {
                        label: this.$t('kvk.huisnummer'),
                        key: 'huisnummer',
                        value: null,
                        category: 2,
                        maxlength: 10,
                        type: FIELD_TYPE.NUMERIC
                    },
                    {
                        label: this.$t('kvk.postbusnummer'),
                        key: 'postbusnummer',
                        value: null,
                        category: 2,
                        maxlength: 10,
                        type: FIELD_TYPE.NUMERIC
                    },
                    {
                        label: this.$t('kvk.huisnummerToevoeging'),
                        key: 'huisnummerToevoeging',
                        value: '',
                        category: 2,
                        maxlength: 4,
                        pattern: '^[0-9a-zA-Z]{1,4}$',
                        title: 'combinatie van hoofdletters, kleine letters en/of cijfers'
                    },
                    {
                        label: this.$t('kvk.woonplaats'),
                        key: 'plaats',
                        value: '',
                        category: 2,
                        maxlength: 100
                    },
                    {
                        label: this.$t('kvk.type'),
                        key: 'type',
                        value: null,
                        category: 3,
                        maxlength: 100,
                        domain: {
                            keyvalues: [
                                {
                                    value: 'hoofdvestiging',
                                    text: this.$t('kvk.typeHeadOffice')
                                },
                                {
                                    value: 'nevenvestiging',
                                    text: this.$t('kvk.typeBranchOffice')
                                },
                                {
                                    value: 'rechtspersoon',
                                    text: this.$t('kvk.typeLegalPerson')
                                }
                            ]
                        }
                    },
                    {
                        label: this.$t('kvk.includingInactive'),
                        key: 'InclusiefInactieveRegistraties',
                        value: false,
                        category: 3,
                        maxlength: 100,
                        domain: {
                            keyvalues: [
                                {
                                    value: false,
                                    text: this.$t('RefcodeNo')
                                },
                                {
                                    value: true,
                                    text: this.$t('RefcodeYes')
                                }
                            ]
                        }
                    }
                ]
            };
        },
        methods: {
            $_onSubmit() {
                let query = {};
                // Only add fields that have a value
                this.inputFields.forEach((item) => {
                    const value =
                        typeof item.value === 'string'
                            ? item.value.trim()
                            : item.value;
                    if (
                        value !== null &&
                        value !== '' &&
                        this.categories[item.category - 1].expanded
                    ) {
                        query[item.key] = value;
                    }
                });
                this.$store.commit('CLEAR_SELECTIONS');
                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_START');
                if (this.$_isValidForm(query)) {
                    this.$store.dispatch('getKvkCompanies', {
                        name: 'GetHandelsregisterData',
                        data: query,
                        title: this.$t('kvk.companies')
                    });
                }
                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_END');
            },
            $_missingSearchFieldsMessage(_query) {
                const query = JSON.parse(JSON.stringify(_query));
                // Ignore optional field
                delete query['InclusiefInactieveRegistraties'];
                // Error when all fields are empty
                if (!(query && Object.keys(query).length > 0)) {
                    return this.$t('kvk.missingSearchFields');
                } else if (
                    // Postcode and huisnummer must both be filled when one of them is filled.
                    (query['postcode'] || query['huisnummer']) &&
                    !(query['postcode'] && query['huisnummer'])
                ) {
                    return this.$t('kvk.incorrectPostcodeHuisnummer');
                } else if (
                    // huisnummer must be filled when huisnummertoevoeging is filled.
                    query['huisnummerToevoeging'] &&
                    !(query['huisnummerToevoeging'] && query['huisnummer'])
                ) {
                    return this.$t('kvk.incorrectHuisnummerToevoeging');
                } else {
                    return '';
                }
            },
            $_isValidForm(query) {
                this.invalidForm = false;
                this.invalidFormErrorMessage =
                    this.$_missingSearchFieldsMessage(query);

                if (this.invalidFormErrorMessage) {
                    this.invalidForm = true;
                    return false;
                }

                if (this.$_hasInvalidStateFields(query)) {
                    this.invalidFormErrorMessage = this.$t(
                        'incorrectInputAllFields'
                    );
                    this.invalidForm = true;
                    return false;
                }
                return true;
            },
            $_hasInvalidStateFields(query) {
                const invalidFields = this.inputFields.filter(
                    ({ state }) => state === false
                );
                return invalidFields.length > 0;
            },
            $_validateInput(field) {
                field.state = !field.value.toString().includes('*');
                this.invalidFieldValueErrorMessage =
                    field.state === true || field.state === null
                        ? ''
                        : this.$t('kvk.wildcarNotSupported');
            }
        }
    };
</script>

<style scoped lang="scss">
.scrollable {
    overflow-y: auto;
}
</style>
